// ScanInputXL - Sprint 44 Fase 3 Vista 7.
// Modal overlay con input invisible para escaner USB/Bluetooth/Android.
// El lector tipea el codigo y termina con Enter. Mantiene foco activo
// mientras el modo escaner esta ON. Tokens + dark mode.
import { useEffect, useRef } from 'react';
import { ensureKeyframes, injectCSS } from '../../design/motion';

const CSS_ID = 'xl-scan-input-css';
const CSS = `
.xl-scan-overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,0.62);
  z-index: 1200;
  display: flex; align-items: center; justify-content: center;
  padding: 16px;
  font-family: var(--xl-font-sans);
}
.xl-scan-modal {
  background: var(--xl-color-surface);
  border: 1px solid var(--xl-color-border);
  border-radius: var(--xl-radius-lg);
  box-shadow: var(--xl-shadow-lg);
  padding: 28px;
  max-width: 420px; width: 100%;
  text-align: center;
  color: var(--xl-color-text);
}
.xl-scan-modal__icon {
  font-size: 44px;
  margin-bottom: 8px;
  display: inline-block;
  animation: xl-scan-pulse 1.4s ease-in-out infinite;
}
@keyframes xl-scan-pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.65; transform: scale(0.92); }
}
@media (prefers-reduced-motion: reduce) {
  .xl-scan-modal__icon { animation: none }
}
.xl-scan-modal__title {
  font-size: 16px; font-weight: 600;
  margin: 0 0 6px;
  color: var(--xl-color-text);
}
.xl-scan-modal__hint {
  font-size: 13px;
  color: var(--xl-color-text-secondary);
  margin: 0 0 14px;
}
.xl-scan-modal__hidden {
  position: absolute; opacity: 0; pointer-events: none;
  width: 1px; height: 1px;
}
.xl-scan-modal__esc {
  font-size: 11px;
  color: var(--xl-color-text-muted);
}
`;

export default function ScanInputXL({
  active, onScan, placeholder = 'Esperando escaneo...',
  title = 'Modo escaneo activo',
}) {
  useEffect(() => { ensureKeyframes(); injectCSS(CSS_ID, CSS); }, []);
  const inputRef = useRef(null);

  useEffect(() => {
    if (!active) return undefined;
    const el = inputRef.current;
    if (el) el.focus();
    const reFocus = () => { if (inputRef.current) inputRef.current.focus(); };
    const onDocClick = () => setTimeout(reFocus, 50);
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, [active]);

  const onKey = (e) => {
    if (e.key === 'Enter') {
      const code = e.currentTarget.value.trim();
      e.currentTarget.value = '';
      if (code) onScan(code);
    }
  };

  if (!active) return null;

  return (
    <div className="xl-scan-overlay xl-motion-fade-in" role="dialog" aria-modal="true">
      <div className="xl-scan-modal">
        <div className="xl-scan-modal__icon" aria-hidden="true">{'\uD83D\uDCF7'}</div>
        <h3 className="xl-scan-modal__title">{title}</h3>
        <p className="xl-scan-modal__hint">{placeholder}</p>
        <input
          ref={inputRef}
          type="text"
          autoFocus
          onKeyDown={onKey}
          className="xl-scan-modal__hidden"
          aria-label="Campo de escaneo"
        />
        <div className="xl-scan-modal__esc">
          Pulsa ESC o el boton para cerrar.
        </div>
      </div>
    </div>
  );
}
